import React, { useState } from 'react';
import api from './api';

/** Génère un mot de passe temporaire lisible, sans caractères ambigus (0/O, 1/l). */
function motDePasseTemporaire() {
  const lettres = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const minuscules = 'abcdefghijkmnpqrstuvwxyz';
  const chiffres = '23456789';
  const tirer = (source, n) =>
    Array.from({ length: n }, () => source[Math.floor(Math.random() * source.length)]).join('');
  return `${tirer(lettres, 1)}${tirer(minuscules, 5)}${tirer(chiffres, 3)}`;
}

function ResetPasswordModal({ user, onClose }) {
  const [motDePasse, setMotDePasse] = useState(motDePasseTemporaire());
  const [confirmation, setConfirmation] = useState('');
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState('');
  const [termine, setTermine] = useState(false);
  const [copie, setCopie] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErreur('');

    if (motDePasse.length < 6) {
      setErreur('Le mot de passe doit contenir au moins 6 caractères.');
      return;
    }

    setEnCours(true);
    try {
      await api.put(`/users/${user.id}/reset-password`, { newPassword: motDePasse });
      setTermine(true);
    } catch (err) {
      setErreur(err.response?.data?.message || 'Impossible de réinitialiser le mot de passe.');
    } finally {
      setEnCours(false);
    }
  };

  const copier = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(motDePasse).then(() => {
        setCopie(true);
        setTimeout(() => setCopie(false), 2000);
      }).catch(() => {});
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ margin: 0 }}>Réinitialiser le mot de passe</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div style={{ marginBottom: 16, fontSize: 13, color: 'var(--text-secondary)' }}>
          Compte : <strong>{user.username}</strong>
          {user.email ? ` · ${user.email}` : ''}
        </div>

        {termine ? (
          <>
            <div
              className="error-message"
              style={{
                marginBottom: 14,
                background: 'rgba(76,175,80,0.12)',
                color: '#3d8b41',
                borderColor: 'rgba(76,175,80,0.3)',
              }}
            >
              Mot de passe réinitialisé.
            </div>

            <p style={{ fontSize: 13, marginBottom: 10 }}>
              Communiquez ce mot de passe à <strong>{user.username}</strong>, et demandez-lui
              de le changer dès sa première connexion depuis son profil.
            </p>

            <div
              style={{
                background: 'var(--bg)',
                border: '1px solid var(--border)',
                borderRadius: 8,
                padding: '14px 16px',
                fontFamily: 'monospace',
                fontSize: 18,
                letterSpacing: 1,
                textAlign: 'center',
                marginBottom: 12,
                userSelect: 'all',
              }}
            >
              {motDePasse}
            </div>

            <button type="button" className="btn btn-sm" onClick={copier} style={{ width: '100%' }}>
              {copie ? 'Copié !' : 'Copier le mot de passe'}
            </button>

            <div className="modal-footer">
              <button type="button" className="btn btn-primary" onClick={onClose}>Fermer</button>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            {erreur && <div className="error-message" style={{ marginBottom: 14 }}>{erreur}</div>}

            <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 14 }}>
              L'ancien mot de passe n'est pas nécessaire. Un mot de passe temporaire a été
              proposé ci-dessous ; vous pouvez le remplacer par celui de votre choix.
            </p>

            <div className="form-group">
              <label>Nouveau mot de passe</label>
              <input
                type="text"
                value={motDePasse}
                onChange={(e) => setMotDePasse(e.target.value)}
                required
                minLength={6}
                style={{ fontFamily: 'monospace' }}
              />
            </div>

            <button
              type="button"
              className="btn btn-sm"
              onClick={() => setMotDePasse(motDePasseTemporaire())}
              style={{ marginBottom: 14 }}
            >
              Générer un autre
            </button>

            <div className="form-group">
              <label>Retapez l'identifiant du compte pour confirmer</label>
              <input
                type="text"
                value={confirmation}
                onChange={(e) => setConfirmation(e.target.value)}
                placeholder={user.username}
                autoComplete="off"
              />
            </div>

            <div className="modal-footer">
              <button type="button" className="btn" onClick={onClose}>Annuler</button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={enCours || confirmation !== user.username}
              >
                {enCours ? 'Réinitialisation...' : 'Réinitialiser'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordModal;
